import { createContext, useContext } from 'react';

export const AsideContext = createContext(false);

export const useInAside = () => {
  const inAside = useContext(AsideContext);

  return inAside;
};
export const WikiContext = createContext(false);

export const useInWiki = () => {
  const inWiki = useContext(WikiContext);
  return inWiki;
};
export const WikiContentContext = createContext(false);
/** 是否在wiki content上，个人知识库返回false */
export const useInWikiContent = () => {
  return useContext(WikiContentContext);
};
